<template>
  <bita-modal
    id="appointment-status-form"
    title="تغییر وضعیت نوبت"
    :is-loading="isLoading"
    @close="reset"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-select
              name="status"
              label="وضعیت نوبت"
              rules="required"
              :validation-container-class="col12"
              :data-source="statusOptions"
              data-text-field="title"
              data-value-field="value"
              v-model="form.status"
            />
          </div>
          <div class="row mt-3" v-if="form.status == 2">
            <div class="col-12 text-danger">
              <i class="fas fa-exclamation-triangle"></i>
              با لغو کردن این نوبت، بازه زمانی ویزیت مربوطه برای رزرو سایر بیماران آزاد خواهد شد.
            </div>
          </div>
        </div>
      </bita-form>
    </div>

    <div slot="footer">
      <bita-bootbutton
        type="primary"
        title="ثبت تغییرات"
        icon="fas fa-save"
        btn-width="120px"
        @click.native="save"
      />
    </div>
  </bita-modal>
</template>

<script>
export default {
  props: {
    isLoading: Boolean,
  },
  data() {
    return {
      col12: "col-lg-12",
      form: {
        id: null,
        status: null,
      },
      statusOptions: [
        { title: "در انتظار", value: 0 },
        { title: "تایید شده", value: 1 },
        { title: "لغو شده", value: 2 },
      ]
    };
  },
  methods: {
    init(data) {
      this.form.id = data.id;
      this.form.status = data.status;
    },
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-save", this.form);
        }
      });
    },
    reset() {
      this.form = { id: null, status: null };
      this.$refs.form.reset();
    },
  },
};
</script>
